module.exports = __webpack_public_path__ + "promotion-banner-tablet.4e4c8bb4743531a92a2da250d3681233.png";